<div class="container-fluid vh-100 vw-100 gx-0 row">
  <div
    [style.background] = "currentSlide.bgColor"
    class="d-flex flex-column flex-md-row text-center row g-0">
    <!-- Left side -->
    <div class="col-md-7 d-none d-md-flex justify-content-center">
      <div [style.background-image]="backgroundImage"
        class="slide-image col-auto col-md-9 d-flex flex-column align-items-center g-0 p-3 justify-content-center">
        <div class="align-items-center rounded-3 d-flex flex-column">
          <div class="p-3">
            <div class="slide-text-container">
              <h4 class="slide-title">{{ currentSlide.mainText }}</h4>
              <div class="slide-subtext">{{ currentSlide.subText }}</div>
            </div>
          </div>
          <div class="d-flex justify-content-center p-3 position-absolute bottom-0 w-100">
            @for (slide of slides; track slide; let index = $index) {
              <button type="button"
                (click)="changeSlide(index)"
                [class.active-div]="index === currentSlideIndex"
                class="slider-controller-div rounded-circle m-2"
                aria-label="Go to slide {{ index + 1 }}">
              </button>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- Right side -->
    <div class="auth-layout-right-side col">
     
      <!-- Logo and Titel -->
      @if(authFormsState.showLoginForm || authFormsState.showRegisterForm || authFormsState.showForgetPasswordForm) {           
        <div class="logo-wrapper d-flex flex-row gap-3 align-items-center justify-content-center">    
          @if(authFormsState.showRegisterForm) {
              <span
                role="button"
                class="return-arrow-wrapper"
                (click)="showLoginForm()"
                >
                <i alt="close" class="return-arrow-icon fa-solid fa-angle-left"></i>
           </span>
            }
            @if(authFormsState.showForgetPasswordForm) {
              <span
                role="button"
                class="return-arrow-wrapper"
                (click)="returnToLoginForm()"
                >
                <i alt="close" class="return-arrow-icon fa-solid fa-angle-left"></i>
            </span>
            }       
          <div class="logo-image">
            <img alt="" src="../../assets/icons/mainG.svg"/>
          </div>

          <p class="logo-text font-sans-serif m-0">
            PETPALS
          </p>
        </div>
      }
      <div class="auth-form-wrapper pt-3 w-100 d-flex justify-content-center">
        <div class="auth-form-content">
          <router-outlet/>
        </div>
      </div>
    </div>
  </div>
</div>

